import React from "react";
import Layout from "../../components/organisms/Layout";
import Details from "../../components/pages/product-detail/Details";
import Insurance from "../../components/molecules/InsuranceList";
import IMG from "../../assets/images/product-detail/company/TRACTOCAMIONES.png";
import { DetailWithImage } from "../../components/pages/quote/DetailWithImage";
import brands from "../../constants/index/brands";
import Technology from "../../components/pages/product-detail/Technology";

const Tractocamiones = ({}) => {
	return (
		<Layout landingPage='company'>
			<Details
				img={brands[11].img}
				type={"tractocamiones"}
				title={"Seguro para Tractocamiones"}
			/>
			<DetailWithImage
				title={
					<h1>
						Apoyo <span className='text-primary'>para tu equipo.</span>
					</h1>
				}
				content='Adicional de cubrir el equipo de trabajo, te ampara legalmente en todos aquellos daños ocasionados a un tercero en el desarrollo de las actividades de la compañía asegurada. Además, brinda protección y respaldo para enfrentar legalmente y cubrir los gastos generados por la reclamación del tercero afectado.'
				image={IMG}
			/>
			<Technology />
			<Insurance
				type='company'
				current='tractocamiones'
				title='Una amplia gama de seguros'
			/>
		</Layout>
	);
};
export default Tractocamiones;
